var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from 'react';
import { useGuard } from '@veeam/core';
import { usePopover, X_AXIS, Y_AXIS } from "../../Popover";
import { Menu, MenuItem } from "../../Menu";
import { getPropsFromDecorators } from "../../Toolbar/getPropsFromDecorators";
import { STACK_DIRECTION, StackView } from "../../StackView";
export function useContextMenu(_a) {
    var items = _a.items, payloadGetter = _a.payloadGetter;
    var canAction = useGuard().canAction;
    var _b = useState(false), contextMenuActive = _b[0], setContextMenuActive = _b[1];
    var _c = useState({
        offsetX: 0,
        offsetY: 0
    }), offsetPosition = _c[0], setOffsetPosition = _c[1];
    var bodyRect = document.body.getBoundingClientRect();
    function getItems() {
        var payload = payloadGetter === null || payloadGetter === void 0 ? void 0 : payloadGetter();
        return items
            .map(function (item) {
            var decoratorProps = getPropsFromDecorators(item.decorators, payload || null, canAction);
            return __assign(__assign(__assign({}, item), decoratorProps), { disabled: item.disabled || decoratorProps.disabled, hidden: item.hidden || decoratorProps.hidden, handler: function (e) {
                    var _a;
                    e.preventDefault();
                    e.stopPropagation();
                    setContextMenuActive(false);
                    if (!item.disabled) {
                        (_a = item.handler) === null || _a === void 0 ? void 0 : _a.call(item);
                    }
                } });
        })
            .filter(function (item) { return !item.hidden; });
    }
    var contextMenu = usePopover({
        isActive: contextMenuActive,
        config: [
            __assign({ xAxis: X_AXIS.insideLeft, yAxis: Y_AXIS.insideTop }, offsetPosition),
            {
                xAxis: X_AXIS.insideRight,
                yAxis: Y_AXIS.insideTop,
                offsetX: -(bodyRect.width - offsetPosition.offsetX),
                offsetY: offsetPosition.offsetY
            },
            {
                xAxis: X_AXIS.insideLeft,
                yAxis: Y_AXIS.insideBottom,
                offsetX: offsetPosition.offsetX,
                offsetY: -(bodyRect.height - offsetPosition.offsetY)
            },
            {
                xAxis: X_AXIS.insideRight,
                yAxis: Y_AXIS.insideBottom,
                offsetX: -(bodyRect.width - offsetPosition.offsetX),
                offsetY: -(bodyRect.height - offsetPosition.offsetY)
            }
        ],
        onOutsideClick: function () {
            if (contextMenuActive) {
                setContextMenuActive(false);
            }
        },
        render: function (popoverRef) {
            return React.createElement(Menu, { ref: popoverRef }, React.createElement(StackView, { direction: STACK_DIRECTION.column }, getItems().map(function (_a) {
                var id = _a.id, title = _a.title, icon = _a.icon, disabled = _a.disabled, handler = _a.handler;
                return (React.createElement(MenuItem, { key: id || Math.random().toString(), "data-selector-id": "context-menu-item" + (id ? "-" + id : ''), disabled: disabled, icon: icon, onClick: handler }, title));
            })));
        },
        target: { measure: function () { return document.body.getBoundingClientRect(); } }
    });
    return {
        element: contextMenu,
        show: function (offsetPosition) {
            if (!getItems().length) {
                return;
            }
            if (offsetPosition) {
                setOffsetPosition(offsetPosition);
            }
            setContextMenuActive(true);
        },
        hide: function () { return setContextMenuActive(false); }
    };
}
//# sourceMappingURL=hooks.js.map